import * as React from 'react';
import classnames from 'classnames';

const classNames = {
  root: 'group-selector',
  selectedItem: 'group-selector__selected',
  items: 'group-selector__items',
  item: 'group-selector__item',
  currentItem: 'group-selector__item--selected',
  expanded: 'group-selector--expanded',
};

export default function GroupDropdown(props) {
  const {
    groups = [],
    groupLabel,
    valueSetter,
  } = props;

  const [label, setLabel] = React.useState('');
  const containerRef = React.useRef(null);

  if (groups.length <= 0) {
    return null;
  }

  React.useEffect(() => {
    setLabel(groups[0]['label']);
  }, [groups]);

  const ToggleDropdown = () => {
    containerRef.current.classList.toggle(classNames.expanded);
  };

  const OnClickHandler = (config) => {
    setLabel(config['label']);
    valueSetter(config['label']);
    ToggleDropdown();
  };

  return (
    <div className={classNames.root} ref={containerRef}>
      <div className={classNames.selectedItem}>
        <button type='button' onClick={ToggleDropdown}>
          {groupLabel}
          <div className="transition-transform rotate-0">
            <svg className="size-[24px]" fill="none" viewBox="0 0 24 24">
              <path d="M7 10l5 5 5-5" stroke="#666666" strokeWidth="2" strokeLinecap="round"
                    strokeLinejoin="round"></path>
            </svg>
          </div>
        </button>
      </div>
      <div className={classNames.items}>
        {groups.map(group => {
          const {
            label: gLabel,
          } = group;

          const itemClassNames = classnames({
            [classNames.item]: true,
            [classNames.currentItem]: gLabel === groupLabel,
          })

          return (
            <div className={itemClassNames} key={gLabel}>
              <button type='button' onClick={() => OnClickHandler(group)}>
                {gLabel}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
